export enum EditAutoPaymentMethodDialogStep {
  VEHICLE = 'vehicle',
  SIMULATOR = 'simulator',
  CHANGES_REVIEW = 'changes_review',
}
